const PlayIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={props.width || '28'}
      height={props.height || '32'}
      viewBox='0 0 28 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M27 13.2679C28.3333 14.0378 28.3333 15.9622 27 16.7321L3 30.7224C1.66667 31.4923 0 30.5301 0 28.9904L0 1.00962C0 -0.530054 1.66667 -1.49228 3 -0.722392L27 13.2679Z'
        fill={props.fill || '#1D1D1F'}
      />
    </svg>
  )
}

export default PlayIcon
